import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class SendingUseridService {
  private messageSource = new BehaviorSubject<number>(0);
  currentMessage = this.messageSource.asObservable();
	constructor() { }
	sendUserId(id: number) {
    this.messageSource.next(id);
  }
}
